/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssociationDetails } from './ApiAssociationDetails';
import {
    ApiAssociationDetailsFromJSON,
    ApiAssociationDetailsFromJSONTyped,
    ApiAssociationDetailsToJSON,
    ApiAssociationDetailsToJSONTyped,
} from './ApiAssociationDetails';
import type { ApiSanctionRecordRole } from './ApiSanctionRecordRole';
import {
    ApiSanctionRecordRoleFromJSON,
    ApiSanctionRecordRoleFromJSONTyped,
    ApiSanctionRecordRoleToJSON,
    ApiSanctionRecordRoleToJSONTyped,
} from './ApiSanctionRecordRole';

/**
 * 
 * @export
 * @interface ApiSanctionRecord
 */
export interface ApiSanctionRecord {
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecord
     */
    externalId: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecord
     */
    aliases?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecord
     */
    summary?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecord
     */
    additionalInformation: string;
    /**
     * 
     * @type {Date}
     * @memberof ApiSanctionRecord
     */
    recordDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ApiSanctionRecord
     */
    notes?: string;
    /**
     * 
     * @type {Array<ApiSanctionRecordRole>}
     * @memberof ApiSanctionRecord
     */
    roles?: Array<ApiSanctionRecordRole>;
    /**
     * 
     * @type {Array<ApiAssociationDetails>}
     * @memberof ApiSanctionRecord
     */
    associations?: Array<ApiAssociationDetails>;
}

/**
 * Check if a given object implements the ApiSanctionRecord interface.
 */
export function instanceOfApiSanctionRecord(value: object): value is ApiSanctionRecord {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('additionalInformation' in value) || value['additionalInformation'] === undefined) return false;
    if (!('recordDate' in value) || value['recordDate'] === undefined) return false;
    return true;
}

export function ApiSanctionRecordFromJSON(json: any): ApiSanctionRecord {
    return ApiSanctionRecordFromJSONTyped(json, false);
}

export function ApiSanctionRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiSanctionRecord {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'aliases': json['aliases'] == null ? undefined : json['aliases'],
        'summary': json['summary'] == null ? undefined : json['summary'],
        'additionalInformation': json['additionalInformation'],
        'recordDate': (new Date(json['recordDate'])),
        'notes': json['notes'] == null ? undefined : json['notes'],
        'roles': json['roles'] == null ? undefined : ((json['roles'] as Array<any>).map(ApiSanctionRecordRoleFromJSON)),
        'associations': json['associations'] == null ? undefined : ((json['associations'] as Array<any>).map(ApiAssociationDetailsFromJSON)),
    };
}

export function ApiSanctionRecordToJSON(json: any): ApiSanctionRecord {
    return ApiSanctionRecordToJSONTyped(json, false);
}

export function ApiSanctionRecordToJSONTyped(value?: ApiSanctionRecord | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'aliases': value['aliases'],
        'summary': value['summary'],
        'additionalInformation': value['additionalInformation'],
        'recordDate': value['recordDate'].toISOString(),
        'notes': value['notes'],
        'roles': value['roles'] == null ? undefined : ((value['roles'] as Array<any>).map(ApiSanctionRecordRoleToJSON)),
        'associations': value['associations'] == null ? undefined : ((value['associations'] as Array<any>).map(ApiAssociationDetailsToJSON)),
    };
}

